<div #cardContainer class="data-card" (click)="onClickDataCard()" *ngIf="currentDataModel && currentDataModel.departureData.locationName">
    <div class="ball"></div>

    <div class="data-card-header">
        <div class="logo-wrapper">
            <!-- <app-svg-loader height="12px" url="assets/third-party-logos/logo-netjets.svg"></app-svg-loader> -->
             <div class="logo-text">NETJETS</div>
        </div>

        <app-flight-location [locationData]="currentDataModel.departureData" [isDeparture]="true" [isPrecise]="true">
        </app-flight-location>

        <app-flight-location *ngIf="currentDataModel.isPreciseDestination === true"
            [locationData]="currentDataModel.arrivalData.preciseDestination" [isDeparture]="false" [isPrecise]="true">
        </app-flight-location>

        <app-flight-location *ngIf="currentDataModel.isPreciseDestination === false"
            [locationData]="currentDataModel.arrivalData.generalDestination" [isDeparture]="false" [isPrecise]="false">
        </app-flight-location>

    </div>

    <div class="primary-data">

        <div class="primary-data-col">
            <app-flight-primary-data [label]="getDateLabel()" [value]="getDateValue()"
                icon="cal-solid.svg"></app-flight-primary-data>
            <app-flight-primary-data [label]="getSeatsLabel()" [value]="getSeatsValue()"
                icon="seat-cube.svg"></app-flight-primary-data>
        </div>

        <div class="primary-data-col">
            <app-flight-primary-data [label]="getTimeLabel()" [value]="getTimeValue()"
                icon="clock-solid.svg"></app-flight-primary-data>
        </div>

    </div>

    <div class="secondary-data">

        <div class="data-container">
            <app-flight-secondary-data label="Bringing Children Under 12"
                [value]="currentDataModel.isBringingChildren ? 'Yes' : 'No'"></app-flight-secondary-data>

            <app-flight-secondary-data label="Bringing Pets"
                [value]="currentDataModel.isBringingPets ? 'Yes' : 'No'"></app-flight-secondary-data>

            <app-flight-secondary-data *ngIf="currentDataModel.reservationData.isExistingReservation" label="Existing Reservation"
                [value]="currentDataModel.reservationData.isExistingReservation ? 'Yes' : 'No'"></app-flight-secondary-data>

            <app-flight-secondary-data *ngIf="currentDataModel.reservationData.isExistingReservation" label="Expecting Flight Mood"
                [value]="currentDataModel.reservationData.expectedMood"></app-flight-secondary-data>

            <app-flight-secondary-data label="Aircraft"
                [value]="currentDataModel.userData.membership?.aircraft"></app-flight-secondary-data>
        </div>

    </div>

</div>